import { render, staticRenderFns } from "./CustomDatePickerTabs.vue?vue&type=template&id=853684f4"
import script from "./CustomDatePickerTabs.vue?vue&type=script&lang=js"
export * from "./CustomDatePickerTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports